import { getRoot, resolveIdentifier, types } from 'mobx-state-tree';
import Paths from '../types/Paths';
import generatePath from '../util/generatePath';
import LinkType from '../types/LinkType';

const Category = types
  .model('Category', {
    id: types.identifierNumber,
    name: types.string,
    name_in_navigation: types.maybeNull(types.string),
    slug: types.string,
    link_type: types.maybeNull(types.string),
    parent_id: types.maybeNull(types.number),
    children: types.optional(types.array(types.late(() => Category)), []),
    discount: types.maybeNull(types.number),
    is_new: types.maybeNull(types.boolean),
    image: types.maybeNull(types.string),
    description_html: types.maybeNull(types.string),
    SEO_title: types.maybeNull(types.string),
    SEO_description: types.maybeNull(types.string),
    footer_description_html: types.maybeNull(types.string),
    show_category_filter: types.maybeNull(types.boolean)
  })
  .views((self) => {
    return {
      getNonBlockedChildren(blockedCategoriesDict) {
        return (
          self.children &&
          self.children.filter(
            (category) => !blockedCategoriesDict[category.id]
          )
        );
      },
      get hierarchy() {
        return [...self.ancestors, self];
      },
      get parentCategory() {
        if (self.parent_id !== null && self.parent_id !== undefined) {
          return resolveIdentifier(Category, getRoot(self), self.parent_id);
        }
        return null;
      },
      get ancestors() {
        const ancestors = [];
        let currentCategory = self;
        while (currentCategory.parentCategory) {
          const parent = currentCategory.parentCategory;
          ancestors.push(parent);
          currentCategory = parent;
        }
        ancestors.reverse();
        return ancestors;
      },
      get mainCategory() {
        return self.hierarchy[0];
      },
      get path() {
        const categories = self.hierarchy;

        if (
          self.link_type === LinkType.EXTERNAL_LINK ||
          self.link_type === LinkType.INTERNAL_LINK
        ) {
          return self.slug;
        }

        return generatePath(Paths.Category, {
          id: self.id,
          rootProductGroup: categories[0].slug,
          productGroup: categories[1] && categories[1].slug,
          subProductGroup: categories[2] && categories[2].slug
        });
      },
      get breadcrumbs() {
        let breadcrumbSections = self.ancestors.map((ancestor) => {
          return {
            text: ancestor.name,
            url: ancestor.path
          };
        });

        breadcrumbSections.push({
          text: self.name,
          url: self.path
        });

        return breadcrumbSections;
      },
      get navigationName() {
        return self.name_in_navigation && self.name_in_navigation.length > 0
          ? self.name_in_navigation
          : self.name;
      }
    };
  });

export default Category;



// WEBPACK FOOTER //
// ./src/models/Category.js